import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { Platform, ModalController } from '@ionic/angular';
import { Plugins, Device } from '@capacitor/core';
const { SplashScreen, Storage } = Plugins;

import { StatusBar } from '@ionic-native/status-bar/ngx';
import { environment } from 'src/environments/environment';
import { LoadingService } from './providers/loading.service';
import { AuthService } from './providers/auth.service';
import { GTMService } from './providers/gtm.service';
import { ReferFriendComponent } from './components/refer-friend/refer-friend.component';
import { AppSplashComponent } from './components/app-splash/app-splash.component';
import { AngularFirestore } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { UtilsService } from './providers/utils.service';

const languageKey = 'language';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  content: any;
  appPages = [];
  loggedIn = false;
  version = '';
  splash = true;
  firstTime = true;
  startup = null;
  languageValue: any;
  constructor(
    private platform: Platform,
    private router: Router,
    private gtmService: GTMService,
    private statusBar: StatusBar,
    private utilsSvc: UtilsService,
    private modalController: ModalController,
    private loadingSvc: LoadingService,
    private authSvc: AuthService,
    private fireDb: AngularFirestore
  ) {
    this.initializeApp();
  }
  
  async ngOnInit() {
    this.languageValue = 'en-US'
    this.version = environment.app.version;
    let languageCode = await Storage.get({ key: languageKey });
    if(languageCode.value === null) {
      const temp = JSON.stringify(await Device.getLanguageCode())
      const language = JSON.parse(temp)
      this.languageValue = language.value
      await Storage.set({ key: languageKey, value: this.languageValue});
    } else {
      const language = languageCode.value;
      this.languageValue = language

    }
    document.documentElement.lang = this.languageValue;
    const contentDocument = await this.getContent().toPromise();
    this.content = this.utilsSvc.translate('menu', this.languageValue, contentDocument);

    this.appPages = [
      {
      title: this.content.menuHome,
      url: '/home',
      icon: 'home'
    },
    {
      title: this.content.menuProfile,
      url: '/profile',
      icon: 'person'
    },
    {
      title: this.content.menuHelp,
      url: '/help',
      icon: 'help-circle'
    },
    {
      title: this.content.menuAbout,
      url: '/about',
      icon: 'information-circle'
    }]

    

    if (this.splash && (this.platform.is("ios") || this.platform.is("android") )) {
      this.presentStartup();
    } else {
      this.splash = false;
    }

    
    this.router.events.subscribe(event => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.loadingSvc.show();
          break;
        }
        case event instanceof NavigationEnd:
          const pageName = event['url'].split("/")[1];
          let menuLink = '';
          switch (pageName) {
            case 'profile':
              menuLink = 'Profile';
              break;
            case 'about':
              menuLink = 'About';
              break;
            case 'help':
              menuLink = "Help";
              break;
            case 'login':
              menuLink = 'Login'
              break;
            default:
              menuLink = 'Home'
          }
          this.gtmService.analyticsEvent('navigation', 'page navigation', 'click', 1, event['url'], {
            "registration-status": this.authSvc.isLoggedIn ? "Logged-in" : "Guest",
            "page-name": pageName,
            "language": this.languageValue,
            "zipcode": "",
            "menu-link": menuLink,
          });
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          if (this.firstTime) {
            if (this.splash) {
              this.closeStartup();
              this.splash = false;
            }
            this.loadingSvc.init();
            this.splash = false;
            this.firstTime = false;
          }
          this.loadingSvc.hide()
          break;
        }
      }
    });
  }

  async logout() {
    await this.authSvc.logoutUser();
    this.router.navigateByUrl('login');
  }

  private initializeApp() {

    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      SplashScreen.hide();
    });
  }

  analyticsEvent(event, category, action, value, item) {
    this.gtmService.analyticsEvent(event, category, action, item, value)
  }

  getContent() {
    return this.fireDb.doc(`content/appContent`).get().pipe(
      map(doc => {
        return doc.data()  
      })
    );
  }

  async presentModal() {
    const modal = await this.modalController.create({
      component: ReferFriendComponent,
    });  
    return await modal.present();
  }
  
  async presentStartup() {
    this.startup = await this.modalController.create({
      component: AppSplashComponent,
    });
    return await this.startup.present();
  }

  async closeStartup() {
    setTimeout(() => {
      this.startup.dismiss();
    }, 2000); 
  }

}
